import { Common } from '@stockbit/ui';

const { Flex } = Common;

import {
  StreamSkeletonContainer,
  ContentWrapper,
  LongBar,
  ShortBar,
  Thumbnail,
} from './styled';

function NewsSkeleton() {
  return (
    <StreamSkeletonContainer>
      <Flex>
        <ContentWrapper>
          {[...new Array(2)].map(() => (
            <LongBar />
          ))}
          <ShortBar />
        </ContentWrapper>

        <Thumbnail height="75px" width="100px" />
      </Flex>
    </StreamSkeletonContainer>
  );
}

export default NewsSkeleton;
